function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import OptionalQuestions from './OptionalQuestions';
import RequiredQuestions from './RequiredQuestions';
import RequireServiceDetails from './RequireServiceDetailsContainer';
var Questions = function Questions(_ref) {
  var methods = _ref.methods,
    onServiceDetailsUpdated = _ref.onServiceDetailsUpdated,
    onServiceDetailsUpdating = _ref.onServiceDetailsUpdating,
    optionalQuestions = _ref.optionalQuestions,
    optionalQuestionsWrapper = _ref.optionalQuestionsWrapper,
    questionsRequiringPreviousSelection = _ref.questionsRequiringPreviousSelection,
    requiredQuestions = _ref.requiredQuestions,
    requiredQuestionsWrapper = _ref.requiredQuestionsWrapper,
    serviceIdentities = _ref.serviceIdentities;
  var _methods$watch = methods.watch(['answers'].concat(_toConsumableArray(requiredQuestions.concat(optionalQuestions).map(function (question) {
      return "answers[".concat(question.label, "]");
    })))),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    answers = _methods$watch2[0];
  return /*#__PURE__*/React.createElement(RequireServiceDetails, {
    serviceIdentities: serviceIdentities,
    onServiceDetailsUpdated: onServiceDetailsUpdated,
    onServiceDetailsUpdating: onServiceDetailsUpdating
  }, /*#__PURE__*/React.createElement("div", {
    className: "questions"
  }, /*#__PURE__*/React.createElement(RequiredQuestions, {
    answers: answers,
    requiredQuestionsWrapper: requiredQuestionsWrapper || 'div',
    requiredQuestions: requiredQuestions,
    questionsRequiringPreviousSelection: questionsRequiringPreviousSelection,
    methods: methods
  }), /*#__PURE__*/React.createElement(OptionalQuestions, {
    answers: answers,
    optionalQuestionsWrapper: optionalQuestionsWrapper || 'div',
    optionalQuestions: optionalQuestions,
    questionsRequiringPreviousSelection: questionsRequiringPreviousSelection,
    methods: methods
  })));
};
export default Questions;